class ApiError {
    constructor(message, code, response) {
        this.message = message;
        this.response = response;
        this.code = code;
    }
    get reason() {
        return this.response;
    }
    get statusCode() {
        return this.code;
    }
    get extra() {
        var _a;
        return (_a = this.response) === null || _a === void 0 ? void 0 : _a.extra;
    }
    get error() {
        var _a;
        return (_a = this.response) === null || _a === void 0 ? void 0 : _a.error;
    }
}

const normalizeSlashUrl = (baseURL = '', url) => {
    const normalizedBaseUrl = baseURL.endsWith('/')
        ? baseURL.slice(0, baseURL.length - 1)
        : baseURL;
    const normalizedPath = url.startsWith('/') ? url.slice(1) : url;
    return `${normalizedBaseUrl}/${normalizedPath}`;
};
const DEFAULT_ERROR_MESSAGE = 'Đã có lỗi xảy ra, vui lòng thử lại sau!';
class Api {
    constructor(url, getError, defaultConfig = {}) {
        this.baseURL = url;
        this.interceptors = [];
        this.getError = getError;
        this.defaultConfig = defaultConfig;
    }
    _parseJson(response) {
        return response.text().then((text) => (text ? JSON.parse(text) : null));
    }
    addInterceptor(interceptFn) {
        this.interceptors.push(interceptFn);
    }
    appendParamsToURL(url, params = {}) {
        if (params) {
            const paramsArr = [];
            for (const k of Object.keys(params)) {
                if (params[k] !== null && params[k] !== undefined) {
                    paramsArr.push(`${k}=${encodeURIComponent(params[k])}`);
                }
            }
            if (paramsArr.length > 0)
                url = `${url}?${paramsArr.join('&')}`;
        }
        return url;
    }
    async request(url, body, method, config = {}) {
        var _a;
        let headers = config.headers || {};
        url = this.appendParamsToURL(url, config.params);
        if (body) {
            if (typeof body !== 'string') {
                if ('append' in body) ;
                else {
                    body = JSON.stringify(body);
                    headers = Object.assign({ 'Content-Type': 'application/json' }, headers);
                }
            }
        }
        const requestObj = Object.assign(Object.assign({}, this.defaultConfig), { method: method, headers: new Headers(headers), body });
        this.interceptors.forEach((fn) => fn(requestObj));
        const res = await fetch(url.startsWith('http') ? url : normalizeSlashUrl(this.baseURL, url), requestObj);
        if (res.status >= 400) {
            const resp = await res.json();
            const error = ((_a = this.getError) === null || _a === void 0 ? void 0 : _a.call(this, resp)) || new ApiError(DEFAULT_ERROR_MESSAGE, -1, resp);
            return Promise.reject(error);
        }
        const respHeaders = {};
        res.headers.forEach((val, key) => (respHeaders[key] = val));
        const data = await this._parseJson(res);
        return { code: res.status, data, headers: respHeaders };
    }
    async get(url, config = {}) {
        return await this.request(url, null, 'GET', config);
    }
    async post(url, body, config = {}) {
        return await this.request(url, body, 'POST', config);
    }
    async patch(url, body, config = {}) {
        return await this.request(url, body, 'PATCH', config);
    }
    async put(url, body, config = {}) {
        return await this.request(url, body, 'PUT', config);
    }
    async delete(url, body = {}, config = {}) {
        return await this.request(url, body, 'DELETE', config);
    }
}

export { ApiError, Api as default };
